module.exports = __webpack_public_path__ + "img/play-01.a3bdde40.jpg";